import React from "react"

import { Plus } from "lucide-react"

import { Button } from "@/components/ui/button"
import { Dialog, DialogTrigger } from "@/components/ui/dialog"

import ViewToggle from "./ViewToggle"

interface EventPageHeaderProps {
  title: string
  viewMode: "grid" | "table" | "kanban" | "calendar"
  setViewMode: (mode: "grid" | "table" | "kanban" | "calendar") => void
  isCreateDialogOpen: boolean
  setIsCreateDialogOpen: (open: boolean) => void
  createButtonLabel: string
  children: React.ReactNode
  showCreateButton?: boolean
  toggleType: "applications" | "trial" | "grid-table"
}

const EventPageHeader: React.FC<EventPageHeaderProps> = ({
  title,
  viewMode,
  setViewMode,
  isCreateDialogOpen,
  setIsCreateDialogOpen,
  createButtonLabel,
  children,
  showCreateButton = true,
  toggleType,
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h1 className="text-2xl font-bold text-secondary">{title}</h1>
      <div className="flex gap-3">
        <ViewToggle viewMode={viewMode} setViewMode={setViewMode} toggleType={toggleType} />

        {showCreateButton && (
          <Dialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen}>
            <DialogTrigger asChild>
              <Button>
                <Plus className="mr-2 h-4 w-4" />
                {createButtonLabel}
              </Button>
            </DialogTrigger>
            {children}
          </Dialog>
        )}
      </div>
    </div>
  )
}

export default EventPageHeader
